import { render, staticRenderFns } from "./CheckCategories.vue?vue&type=template&id=83901b62&scoped=true&"
import script from "./CheckCategories.vue?vue&type=script&lang=js&"
export * from "./CheckCategories.vue?vue&type=script&lang=js&"
import style0 from "./CheckCategories.vue?vue&type=style&index=0&id=83901b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83901b62",
  null
  
)

export default component.exports